'use client';

import { useState } from 'react';
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import { ClientBrandConfig } from 'types/brand-config';

import { BookingGuarantee } from './guarantees';
import GuaranteeItem from './guareantee-item';

interface GuaranteePopoverProps {
  guarantees: BookingGuarantee[];
  brand: ClientBrandConfig;
}

const GuaranteePopover = ({ guarantees, brand }: GuaranteePopoverProps) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        className="p-0 text-xs font-medium text-secondary-main hover:text-link lg:text-sm"
      >
        Learn more
      </button>
      <Dialog open={open} onClose={handleClose} className="relative z-20">
        <DialogBackdrop
          transition
          className="fixed inset-0 z-20 h-full w-dvw bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-20 h-full w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <DialogPanel
              transition
              className="relative w-full max-w-md transform overflow-hidden rounded-xl bg-white px-6 pb-6 pt-6 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in dark:bg-gray-900"
            >
              <button
                type="button"
                onClick={handleClose}
                className="absolute right-0 top-0 z-20 p-4 text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 48 48"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                    d="m8 8l32 32M8 40L40 8"
                  />
                </svg>
              </button>
              <DialogTitle>
                <div className="flex flex-col justify-center gap-4">
                  <div className="flex h-16 w-16 items-center justify-center self-center rounded-full bg-primary-light p-4 text-white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4zm-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m-2-4l-4-4l1.41-1.41L10 14.17l6.59-6.59L18 9"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col gap-2">
                    <h2 className="text-center text-xl font-bold text-primary-main">
                      {brand.title} Guarantee
                    </h2>
                    <p className="text-center text-sm font-normal text-gray-500">
                      Book with confidence. We&apos;ve got you covered.
                    </p>
                  </div>
                </div>
              </DialogTitle>
              <div className="mt-6 flex flex-col gap-4">
                {guarantees.map((guarantee) => (
                  <GuaranteeItem
                    key={`${guarantee.id}-popover`}
                    guarantee={guarantee}
                    showDetails={true}
                  />
                ))}
              </div>
              <div className="mx-auto px-4">
                <button
                  type="button"
                  onClick={handleClose}
                  className=" mt-4 w-full rounded-lg bg-primary-main font-medium text-white hover:bg-primary-light focus:outline-none"
                >
                  Got it
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default GuaranteePopover;
